import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import InvestigationsCapaManagement, { CAPA_META_TITLE, CAPA_META_DESCRIPTION, CAPA_HERO_IMAGE } from "@/pages/InvestigationsCapaManagement";

export const Route = createFileRoute("/en/services/quality-assurance/quality-compliance-remediation-capa")({
  head: () =>
    buildRouteHead("/en/services/quality-assurance/quality-compliance-remediation-capa", {
      title: CAPA_META_TITLE,
      description: CAPA_META_DESCRIPTION,
      ogImage: CAPA_HERO_IMAGE,
    }),
  component: InvestigationsCapaManagement,
});
